/**
 * 🔴 El aviso de que un listado LLEGÓ AL TOPE del backend.
 *
 * `GET /consola/conductores` y `GET /consola/viajes` cortan en 200 filas (`take: TOPE_FILAS`) y
 * **la respuesta no trae ninguna marca de que cortaron**: 200 filas y 200-de-5000 son la misma
 * respuesta, mismo status, mismo cuerpo bien formado. Sin este aviso, la pantalla afirma en
 * silencio que está mostrando todo — y un listado truncado que se lee como completo es peor que
 * uno vacío: el vacío se nota, el truncado no.
 *
 * ⚠️ **Dice «puede haber más», nunca «hay más», y esa palabra está elegida.** Llegar a exactamente
 * 200 filas es compatible con dos mundos: la base tiene 200 justas (nada se perdió) o tiene 5000
 * y se cortó. La cantidad NO discrimina entre los dos, y el backend no ofrece hoy ninguna señal
 * que sí lo haga (no hay `total`, ni `hasMore`, ni cabecera de paginación). Afirmar «hay más»
 * sería inventar la mitad del caso; afirmar «está todo» sería inventar la otra. Lo honesto es
 * decir que no se puede saber y qué hacer al respecto.
 *
 * ⚠️ **Y la consecuencia que casi nunca se piensa, por eso está escrita en el texto que ve el
 * operador: la búsqueda de la pantalla es CLIENT-SIDE.** Filtra dentro de las filas que llegaron,
 * así que con el tope alcanzado un «no coincide nada» no significa que no exista: puede estar
 * fuera de las 200. Por eso el aviso empuja a acotar con el filtro de estado, que SÍ viaja al
 * backend y hace que el tope se aplique al conjunto ya filtrado.
 */
export function AvisoTope({ tope, sugerencia }: { tope: number; sugerencia: string }) {
  return (
    <div
      role="status"
      className="campo__ayuda"
      style={{
        margin: '0 18px 12px',
        padding: '8px 11px',
        border: '1px solid var(--ambar)',
        background: 'var(--ambar-fondo)',
        color: 'var(--ambar)',
      }}
    >
      <strong>Se alcanzó el tope de {tope} filas del backend.</strong> Puede haber más que no se
      están mostrando — el backend corta en {tope} y no avisa cuál de los dos casos es. La búsqueda
      de esta pantalla recorre sólo lo que llegó, así que «nada coincide» tampoco es concluyente
      mientras este aviso esté visible. {sugerencia}
    </div>
  );
}
